import DocumentationWrapper from '../../CompanyDocumentation/SubComponents/DocumentationWrapper';
import { CommonDocumentationApp } from '../../CompanyDocumentation/Functionality/CommonDocumentationApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CompanySection = ({ userTypeId, userId, profile, historyModel, noInformationTitle }) => {
    const {
        t,
        subView,
        handleSubViewChange,
    } = CommonDocumentationApp();

    return (
        <DocumentationWrapper
            t={t}
            subView={subView}
            handleSubViewChange={handleSubViewChange}
            id={userId}
            userTypeId={userTypeId}
            profile={profile}
            historyModel={historyModel}
            noInformationTitle={noInformationTitle}
        />
    );
};

export default CompanySection;
